/* eslint-disable camelcase */
import {
    CHECK_PRODUCT_BOM_SUCCESS,
    CHECK_PRODUCT_BOM_FAILURE,
} from '../actions/actionTypes';

import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* checkProductBomDetails(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const { orderType, productCFN, salesOrg } = action.payload;

    const url = `/occ/v2/${baseSiteId}/products/checkProductBOM?orderType=${encodeURIComponent(orderType)}&productCFN=${encodeURIComponent(productCFN)}&salesOrg=${encodeURIComponent(salesOrg)}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: CHECK_PRODUCT_BOM_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: CHECK_PRODUCT_BOM_FAILURE,
            payload: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
